<template>
  <div class="capture">
    <header-picture :close="false" :back="!uploadImage"></header-picture>
    <div class="capture__photo">
      <!-- <img ref="photoPreview"> -->
      <vue-cropper
        v-if="loadPreview"
        ref="cropper"
        :src="photoPreviewSrc"
        alt="Crop image"
        :aspectRatio="1"
      >
      </vue-cropper>
    </div>
    <div class="capture__photo__inflable__container" v-if="!loadPreview">
      <h3>{{$t("picture.intro")}}</h3>
      <span>{{$t("picture.introLegend")}}</span>
    </div>
    <div class="capture__actions" :class="{'one-item': !loadPreview}">
      <!-- Remove -->
      <button class="capture__actions__remove" v-show="loadPreview" @click="removeCapture" :disabled="uploadImage" :class="{'disabled' : uploadImage}">
        {{$t("picture.remove")}}
      </button>
      <!-- Camera -->
      <label v-if="isApp" class="capture__actions__photo" :class="{'click-me': !loadPreview, 'disabled': uploadImage}" @click="captureImage()">
        <img src="@/assets/cam.svg">
      </label>
      <label v-else class="capture__actions__photo" :class="{'click-me': !loadPreview, 'disabled': uploadImage}">
        <img src="@/assets/cam.svg" alt="">
        <input type="file" @change="uploadPreview" accept="image/*" capture="camera" id="fileUpload" />
      </label>
      <!-- Confirm -->
      <button class="capture__actions__confirm" v-show="loadPreview" @click="confirmCapture" :disabled="uploadImage" :class="{'disabled': uploadImage}">
        {{$t("picture.confirm")}}
        <img src="@/assets/dropdown.png" alt="">
      </button>
    </div>
  </div>
</template>

<script>
import HeaderPicture from '@/components/Header/Picture.vue'
import storage from "@/plugins/azure-storage"
import cropImage from "@/plugins/cropImages"
import VueCropper from 'vue-cropperjs';
import { mapState } from 'vuex';
import 'cropperjs/dist/cropper.css';

export default {
  components: {
    HeaderPicture,
    VueCropper
  },
  data() {
    return {
      loadPreview: false,
      uploadImage: false,
      eventUploadImage: null,
      photoPreviewSrc: '',
      isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent))
    }
  },
  computed: {
    ...mapState({
      profile: state => state.ProfileModule.profile
    }),
    isApp(){
      return window["cordova"] != undefined
    }
  },
  created() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    
    if (Object.keys(this.profile).length == 0) {
      this.$store.dispatch('profileGet')
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.isMobile) {
        if (this.isApp && window["cordova"].platformId.toLowerCase() != 'ios') {
          this.captureImage()
        } else {
          document.getElementById("fileUpload").click()
        }
      }
    }, 0)
  },
  methods: {
    uploadPreview(e) {
      if (!e.target.files[0].type.includes("image")) return;
      this.removeCapture()
      setTimeout(() => {
        this.eventUploadImage = e;
        this.photoPreviewSrc = URL.createObjectURL(e.target.files[0])
        this.loadPreview = true
      }, 100)
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), 
          n = bstr.length, 
          u8arr = new Uint8Array(n);
          
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      
       const fileData = new File([u8arr], filename, {type:mime});
       return fileData;
    },
    captureImage() {
      if (this.uploadImage) return; 
      
			let cameraConfig = {
				quality: 50,
				sourceType: 1,
				destinationType: navigator.camera.DestinationType.DATA_URL,
				encodingType: navigator.camera.EncodingType.JPEG,
				mediaType: navigator.camera.MediaType.PICTURE,
        cameraDirection: navigator.camera.Direction.BACK,
        correctOrientation : true
      };
      this.$store.dispatch("addNotification", {
        value: this.$t('notifications.loadingCamera'),
        status: 'success',
        remove: false
      })
			navigator.camera.getPicture(
				data => { 
          this.$store.dispatch('removeNotification', 0)
          this.processPicture(data) 
          setTimeout(()=>{
            window.StatusBar.hide();
            window.StatusBar.show();
          },100)
        },
				error => { 
          console.log(error) 
          setTimeout(()=>{
            this.$store.dispatch('removeNotification', 0)
            window.StatusBar.hide();
            window.StatusBar.show();
          },100)
        },
				cameraConfig
			)
    },
    async processPicture (path) {
      this.uploadPreview({ target : { files : [ this.dataURLtoBlob(path, 'image/jpg', 'jpg')] } } )
    },
    dataURLtoBlob (b64Data, contentType, extension, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      blob['name'] = `${this.profile.firstName}-${this.profile.lastName}--${new Date().getTime()}.${extension}`;
      blob['lastModified'] = new Date();
      return blob;
    },
    async confirmCapture() {
      if (this.photoPreviewSrc == '' || this.uploadImage) return

      this.uploadImage = true;

      this.$store.dispatch("addNotification", {
        value: this.$t('notifications.uploadPicture'),
        status: 'success',
        remove: false
      })

      if(this.isApp)
      {
        this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          blob.name = `${this.profile.firstName}-${this.profile.lastName}--.jpg`
          this.updateFile(blob)
        }, "image/jpg")
      }
      else
      {
        const image = this.dataURLtoFile(this.$refs.cropper.getCroppedCanvas().toDataURL(), `${this.profile.firstName}-${this.profile.lastName}--.png`)
        this.updateFile(image)
      } 
      
    },
    async updateFile(image) {
      // Cropped image TODO
      const imageCropped = await cropImage.crop(image, 500, 500, `${this.profile.firstName}-${this.profile.lastName}--.png`, 'image/png')
      
      storage.updateFile(imageCropped, process.env.VUE_APP_CDN_CONTAINERFANPICTURES, `${this.profile.firstName}-${this.profile.lastName}`).then(picture => {
        const modelPicture = {
          gameId: this.$route.params.idGame,
          teamId: this.$route.params.idTeam,
          picture
        }
        this.$store.dispatch("sendPicture", modelPicture)
        this.$store.dispatch('removeNotification', 0)
        this.$router.push(`/game/${modelPicture.gameId}/${modelPicture.teamId}/picture/successfull`)
      })
    },
    removeCapture() {
      if (this.uploadImage) return; 
      this.photoPreviewSrc = ''
      this.loadPreview = false
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.capture {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);

  &__photo {

    img {
      object-fit: contain;
      width: 100%;
    }

    &__inflable__container {
      position: relative;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: $white;
      width: 100%;
      max-width: 280px;
      text-align: center;

      img {
        margin-bottom: $margin-kilo;
      }
    }
  }

  &__actions {
    position: absolute;
    bottom: 48px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    z-index: 3;
    padding-bottom: env(safe-area-inset-bottom);
    height: 64px;

    @media (min-width: $break-sm) {
      left: 50%;
      width: 480px;
      margin-left: -240px;
    }

    &.one-item {
      justify-content: center;
    }

    &__photo {
      width: 64px;
      height: 64px;
      z-index: 2;
      color: $white;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 3px solid $lightblue;
      border-radius: $margin-base;
      background: #07559D;
      box-shadow: $shadow;
      flex-shrink: 0;
      
      img {
        width: 38px;
      }

      &.click-me {
        animation: jittery 2s infinite;
      }
      
      input {
        display: none;
      }

      &.disabled {
        opacity: .5;
      }
    }

    button {
      height: 40px;
      color: $blue;
      padding: 0 $margin-base;
      background: $white;
      border-radius: 20px;
      font-weight: 600;
      display: flex;
      align-items: center;
      @include font-settings(milli,base);
      position: relative;
      box-shadow: $shadow;

      &.disabled {
        opacity: .5;
      }
    }

    &__remove {
      background: tomato!important;
      color: $white!important;
    }

    &__confirm {
      padding-right: $margin-mega!important;
      
      img {
        margin-left: $margin-small;
        transform: rotate(-90deg);
        position: absolute;
        right: 8px;
        top: 13px;
        width: 21px;
      }
    }
  }
}
</style>